import * as angular from "angular";
import * as _ from "lodash";
import {DeliveriesService} from "../../deliveries/services/deliveries-service.service";
import {SiteContextService} from "../../commons/services/site-context.service";
import {CommonsService} from "../../commons/services/commons-service.service";
import {ActionReasonEnum} from "../enums/action-reason.enum";
import {ActionReasonModel} from "../models/action-reason.model";
import {ActionReasonVisibilityEnum} from "../enums/action-reason-visibility.enum";
import {ActionReasonEntityEnum} from "../enums/action-reason-entity.enum";
import {TaskStatusType} from "../../tasks/types/taskStatus.type";
import {Service} from "../../deliveries/models/service.model";
import {TaskModel} from "../../tasks/models/task.model";
import {TaskPurposeType} from "../../commons/types/task-purpose.type";

export class ActionReasonsDialogsServiceService {

  servicesRef: any;
  public taskStatusType: typeof TaskStatusType = TaskStatusType;
  public actionReasonType: typeof ActionReasonEnum = ActionReasonEnum;
  public taskPurposeType: typeof TaskPurposeType = TaskPurposeType;

  /* @ngInject */
  constructor(private $mdDialog, private $filter, private commonsConstants, private $delivery, private siteContextService: SiteContextService) {
    this.servicesRef = this.$delivery();
  }

  createActionReason(actions, actionReasonEntity: ActionReasonEntityEnum, event) {
    const self = this;
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      template: require('./../views/add-action-reason.html').default,
      controller: function ($scope) {

        $scope.title = 'Add';
        $scope.actionReasonEntities = ActionReasonEntityEnum;
        $scope.actionTypesEnum = ActionReasonEnum;
        $scope.actionsOptions = angular.copy(actions);
        $scope.actionReasonTypes = Object.values(ActionReasonEnum);


        $scope.taskStatusType = self.taskStatusType;
        $scope.taskStatuses = [
          TaskStatusType.Unassigned,
          TaskStatusType.Assigned,
          TaskStatusType.CourierHeading,
          TaskStatusType.CourierArrived,
          TaskStatusType.Canceled
        ];
        $scope.actionReasonType = self.actionReasonType;


        $scope.actionReason = {
          reason: undefined,
          externalId: undefined,
          actions: [],
          description: undefined,
          entityType: actionReasonEntity,
          pickupStatuses: [],
          dropoffStatuses: [],
          operationStatuses: [],
          type: undefined
        }

        $scope.consoleEnabled = true;
        $scope.agentAppEnabled = actionReasonEntity !== ActionReasonEntityEnum.OmsOrder;

        $scope.cancel = self.$mdDialog.cancel;

        $scope.onSelectActionReasonType = (type) => {
          $scope.actionReason.type = type;
          $scope.actionReason.pickupStatuses = [];
          $scope.actionReason.dropoffStatuses = [];
          $scope.actionReason.operationStatuses = [];
        }

        $scope.toggleAgentAppAvailability = (agentAppEnabled: boolean) => {
          $scope.agentAppEnabled = !agentAppEnabled;
        }

        $scope.toggleConsoleAvailability = (consoleEnabled: boolean) => {
          $scope.consoleEnabled = !consoleEnabled;
        }

        $scope.onEntityTypeChange = () => {
          $scope.actionReason.pickupStatuses = [];
          $scope.actionReason.dropoffStatuses = [];
          $scope.actionReason.operationStatuses = [];
          $scope.actionReason.type = undefined;

          $scope.actionReasonTypes = ($scope.actionReason.entityType === ActionReasonEntityEnum.OmsOrder) ?
            Object.values(ActionReasonEnum).filter(function(type: ActionReasonEnum) {
              return type !== ActionReasonEnum.MissingItems;
            }) :
            Object.values(ActionReasonEnum);
        }

        $scope.onChangePickupStatuses = (values) => {
          $scope.actionReason.pickupStatuses = values;
        }

        $scope.onChangeDropoffStatuses = (values) => {
          $scope.actionReason.dropoffStatuses = values;
        }

        $scope.onChangeOperationStatuses = (values) => {
          $scope.actionReason.operationStatuses = values;
        }

        $scope.submit = (form) => {
          if (form) {
            form.$setSubmitted(true);
            if (form.$valid) {

              const actionReasonVisibilitiesList = [];
              if ($scope.agentAppEnabled && $scope.actionReason.entityType !== $scope.actionReasonEntities.OmsOrder) {
                actionReasonVisibilitiesList.push(ActionReasonVisibilityEnum.Agent);
              }
              if ($scope.consoleEnabled) {
                actionReasonVisibilitiesList.push(ActionReasonVisibilityEnum.Admin);
              }
              _.set($scope.actionReason, 'visibilities', actionReasonVisibilitiesList);
              self.$mdDialog.hide($scope.actionReason);
            }
          }
        };
      },
      targetEvent: event,
      fullscreen: true,
      clickOutsideToClose: false
    })
  }

  updateActionReason(actions, actionReason: ActionReasonModel, event) {
    const self = this;
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      template: require('./../views/add-action-reason.html').default,
      controller: function ($scope) {
        if (!actionReason.actions) {
          actionReason.actions = [];
        }

        $scope.title = 'Edit';
        $scope.actionsOptions = angular.copy(actions);
        $scope.actionReasonEntities = ActionReasonEntityEnum;
        $scope.actionTypesEnum = ActionReasonEnum;
        $scope.actionReason = angular.copy(actionReason);
        $scope.actionReasonVisibilitiesType = ActionReasonVisibilityEnum;
        $scope.actionReasonTypes = Object.values(ActionReasonEnum);
        $scope.taskStatusType = self.taskStatusType;
        $scope.taskStatuses = [
          TaskStatusType.Unassigned,
          TaskStatusType.Assigned,
          TaskStatusType.CourierHeading,
          TaskStatusType.CourierArrived,
          TaskStatusType.Canceled
        ];
        $scope.actionReasonType = self.actionReasonType;

        $scope.actionReasonVisibilitiesList = _.get($scope.actionReason, 'visibilities', []);
        $scope.agentAppEnabled = !!_.find($scope.actionReasonVisibilitiesList, (crv) => {
          return crv === ActionReasonVisibilityEnum.Agent;
        });
        $scope.consoleEnabled = !!_.find($scope.actionReasonVisibilitiesList, (crv) => {
          return crv === ActionReasonVisibilityEnum.Admin;
        })

        //setting the actionsOptions Mandatory fields as the cancellationReason mandatory fields
        _.forEach($scope.actionReason.actions, (chosenAction) => {

          let actionOptions = _.find($scope.actionsOptions, (actionOption) => {
            return actionOption.type === chosenAction.type;
          })

          if (actionOptions.mandatory)
            actionOptions.mandatory = chosenAction.mandatory;
        })

        $scope.onActionsChange = (actions) => {
          $scope.actionReason.actions = actions;
        }

        $scope.onSelectActionReasonType = (type) => {
          $scope.actionReason.type = type;
          $scope.actionReason.pickupStatuses = [];
          $scope.actionReason.dropoffStatuses = [];
          $scope.actionReason.operationStatuses = [];
        }



        $scope.toggleAgentAppAvailability = (agentAppEnabled: boolean) => {
          $scope.agentAppEnabled = !agentAppEnabled;
        }

        $scope.toggleConsoleAvailability = (consoleEnabled: boolean) => {
          $scope.consoleEnabled = !consoleEnabled;
        }

        $scope.onEntityTypeChange = () => {
          $scope.actionReason.pickupStatuses = [];
          $scope.actionReason.dropoffStatuses = [];
          $scope.actionReason.operationStatuses = [];
          $scope.actionReason.type = undefined;
          $scope.actionReasonTypes = ($scope.actionReason.entityType === ActionReasonEntityEnum.OmsOrder) ?
            Object.values(ActionReasonEnum).filter(function(type: ActionReasonEnum) {
              return type !== ActionReasonEnum.MissingItems;
            }) :
            Object.values(ActionReasonEnum);
        }

        $scope.onChangePickupStatuses = (values) => {
          $scope.actionReason.pickupStatuses = values;
        }

        $scope.onChangeDropoffStatuses = (values) => {
          $scope.actionReason.dropoffStatuses = values;
        }

        $scope.onChangeOperationStatuses = (values) => {
          $scope.actionReason.operationStatuses = values;
        }

        $scope.cancel = self.$mdDialog.cancel;

        $scope.submit = (form) => {
          if (form) {
            form.$setSubmitted(true);
            if (form.$valid) {

              const actionReasonVisibilitiesList = [];
              if ($scope.agentAppEnabled && $scope.actionReason.entityType !== $scope.actionReasonEntities.OmsOrder) {
                actionReasonVisibilitiesList.push(ActionReasonVisibilityEnum.Agent);
              }
              if ($scope.consoleEnabled) {
                actionReasonVisibilitiesList.push(ActionReasonVisibilityEnum.Admin);
              }
              _.set($scope.actionReason, 'visibilities', actionReasonVisibilitiesList);
              self.$mdDialog.hide($scope.actionReason);
            }
          }
        };
      },
      targetEvent: event,
      fullscreen: true,
      clickOutsideToClose: false
    })
  }

  createCancelTaskReason(serviceIds, event?, includeRemoveCheckbox?, header?, entities?) {
    const self = this;
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      template: require('./../views/cancel-task-reason.html').default,
      controller: function ($scope, commonsService: CommonsService, $log, $mdMedia, deliveriesService: DeliveriesService) {

        $scope.isCancellationCommentMandatory = self.siteContextService.getSiteInfo().serviceCustomizedFields.cancelServiceCommentIsMandatory;
        $scope.serviceIds = serviceIds;
        $scope.header = header;
        $scope.selectedServices = undefined;
        $scope.cancelableServices = undefined;
        $scope.unCancelableServices = undefined;
        $scope.cancelRelatedChecked = undefined;
        $scope.isRouted;
        $scope.cancellationReasonVisibilitiesType = ActionReasonVisibilityEnum;

        $scope.actionReasonTypes = [ActionReasonEnum.Cancel];
        $scope.actionReasonVisibiltyTypes = ActionReasonVisibilityEnum;

        $scope.isMobile = !$mdMedia('gt-md');

        $scope.calcRouted = () => {
          $scope.isRouted = false;
          let totalServices = $scope.selectedServices;
          if ($scope.cancelRelatedChecked) {
            totalServices = _.union($scope.selectedServices, $scope.cancelableServices)
          }
          _.forEach(totalServices, service => {
            if (service.routeId) {
              $scope.isRouted = true;
              return;
            }
          })

        };

        self.servicesRef.$getAll({ids: serviceIds})
          .then((ids: string[]) => {
            return self.servicesRef.$asyncValues(ids);
          })
          .then((services: Service[]) => {
            $scope.selectedServices = services;

            $scope.actionReasonEntities = [];
            $scope.pickupStatuses = [];
            $scope.dropoffStatuses = [];
            $scope.operationStatuses = [];
            services.forEach((s: Service) => {
              if (s.serviceType) {
                $scope.actionReasonEntities.push(s.serviceType);
              }
              s.taskList.forEach((t: TaskModel) => {
                if (t.taskSpec.purpose === self.taskPurposeType.Pickup) {
                  $scope.pickupStatuses.push(t.status);
                }
                if (t.taskSpec.purpose === self.taskPurposeType.Dropoff) {
                  $scope.dropoffStatuses.push(t.status);
                }
                if (t.taskSpec.purpose === self.taskPurposeType.Operation) {
                  $scope.operationStatuses.push(t.status);
                }
              })
            })
            $scope.actionReasonEntities = _.uniq($scope.actionReasonEntities);
            $scope.pickupStatuses = _.uniq($scope.pickupStatuses);
            $scope.dropoffStatuses = _.uniq($scope.dropoffStatuses);
            $scope.operationStatuses = _.uniq($scope.operationStatuses);

            $scope.cancellationReasonTypes = _.uniq(_.map(services, 'serviceType'));
            const relatedServiceIds = deliveriesService.getRelatedServicesByTypeMultiple(services, "SupplyTogether");
            return self.servicesRef.$asyncValues(relatedServiceIds)
          })
          .then((relatedServices) => {

            const cancelableServices = relatedServices.filter((relatedService) => {
              return !(relatedService.status == "Completed" || relatedService.status == "Canceled");
            });

            const unCancelableServices = _.differenceBy(relatedServices, cancelableServices);

            $scope.cancelableServices = angular.copy(cancelableServices);
            $scope.unCancelableServices = angular.copy(unCancelableServices);

            $scope.cancelRelatedChecked = !!$scope.cancelableServices?.length;

            $scope.calcRouted();

          });

        $scope.includeRemoveCheckbox = includeRemoveCheckbox;
        $scope.selectedCancellationReason = undefined;

        $scope.cancelTaskReason = {
          reason: undefined,
          externalId: undefined,
          description: undefined,
          actions: [],
          comment: undefined,
          attachments: [],
          serviceType: undefined,
          removeFromRoute: true
        }

        $scope.onCancelableServicesToggled = () => {
          $scope.cancelRelatedChecked = !$scope.cancelRelatedChecked;
          $scope.calcRouted();
        }

        $scope.onChangeCancellationReason = (cancellationReason: ActionReasonModel) => {
          if (!cancellationReason) return;
          $scope.selectedCancellationReason = cancellationReason;
          $scope.cancelTaskReason.reason = cancellationReason.reason;
          $scope.cancelTaskReason.externalId = cancellationReason.externalId;
          $scope.cancelTaskReason.description = cancellationReason.description;
          $scope.cancelTaskReason.actions = cancellationReason.actions;
          $scope.cancelTaskReason.typeToCancel = cancellationReason.entityType;
        }

        $scope.onAddAttachment = () => {
          commonsService.fileUpload(self.commonsConstants.fileConstants.upload.images)
            .then(function (result) {
              $scope._afterUpload(result);
            })
            .catch(function () {
              $log.info('Closed File Upload')
            })
        }

        $scope.onRemoveAttachment = (index) => {
          $scope.cancelTaskReason.attachments.splice(index, 1);
        }

        $scope._afterUpload = (uploadedResult) => {
          const imageUrl = _.get(uploadedResult, 'url'),
            mimeType = _.get(uploadedResult, 'contentType');

          if (imageUrl) {
            const attachment = {
              url: imageUrl,
              mimeType: mimeType
            };
            $scope.cancelTaskReason.attachments.push(attachment);
          }
        }

        $scope.cancel = self.$mdDialog.cancel;

        $scope.submit = (form) => {
          if (form) {
            form.$setSubmitted(true);
            if (form.$valid) {
              let cancelableServicesIds = [];
              if ($scope.cancelRelatedChecked) {
                cancelableServicesIds = _.map($scope.cancelableServices, (s) => {
                  return s.id
                })
              }

              self.$mdDialog.hide({
                cancelReason: $scope.cancelTaskReason,
                relatedServicesIds: cancelableServicesIds
              });
            }
          }
        };
      },
      targetEvent: event,
      fullscreen: true,
      clickOutsideToClose: false
    })
  }

  createRevertTaskReason(serviceIds, event?, includeRemoveCheckbox?, header?, entities?) {
    const self = this;
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      template: require('./../views/revert-task-reason.html').default,
      controller: function ($scope, commonsService: CommonsService, $log, $mdMedia, deliveriesService: DeliveriesService) {

        // $scope.isCancellationCommentMandatory = this.siteContextService.getSiteInfo().serviceCustomizedFields.cancelServiceCommentIsMandatory;
        $scope.serviceIds = serviceIds;
        $scope.revertReasonVisibilitiesType = ActionReasonVisibilityEnum;

        $scope.actionReasonTypes = [ActionReasonEnum.Revert];
        $scope.actionReasonVisibiltyTypes = ActionReasonVisibilityEnum;

        $scope.isMobile = !$mdMedia('gt-md');

        $scope.revertTaskReason = {
          reason: undefined,
          externalId: undefined,
          description: undefined,
          actions: [],
          comment: undefined,
          attachments: [],
          type: ActionReasonEnum.Revert
        }

        self.servicesRef.$getAll({ids: serviceIds})
          .then((ids: string[]) => {
            return self.servicesRef.$asyncValues(ids);
          })
          .then((services: Service[]) => {
            $scope.selectedServices = services;

            $scope.actionReasonEntities = [];
            $scope.pickupStatuses = [];
            $scope.dropoffStatuses = [];
            $scope.operationStatuses = [];
            services.forEach((s: Service) => {
              if (s.serviceType) {
                $scope.actionReasonEntities.push(s.serviceType);
              }
              s.taskList.forEach((t: TaskModel) => {
                if (t.taskSpec.purpose === self.taskPurposeType.Pickup) {
                  $scope.pickupStatuses.push(t.status);
                }
                if (t.taskSpec.purpose === self.taskPurposeType.Dropoff) {
                  $scope.dropoffStatuses.push(t.status);
                }
                if (t.taskSpec.purpose === self.taskPurposeType.Operation) {
                  $scope.operationStatuses.push(t.status);
                }
              })
            })
            $scope.actionReasonEntities = _.uniq($scope.actionReasonEntities);
            $scope.pickupStatuses = _.uniq($scope.pickupStatuses);
            $scope.dropoffStatuses = _.uniq($scope.dropoffStatuses);
            $scope.operationStatuses = _.uniq($scope.operationStatuses);
          })

        $scope.onChangeRevertReason = (revertReason: ActionReasonModel) => {
          if (!revertReason) return;
          $scope.selectedRevertReason = revertReason;
          $scope.revertTaskReason.reason = revertReason.reason;
          $scope.revertTaskReason.externalId = revertReason.externalId;
          $scope.revertTaskReason.description = revertReason.description;
          $scope.revertTaskReason.actions = revertReason.actions;
          $scope.revertTaskReason.entityType = revertReason.entityType;
        }

        $scope.onAddAttachment = () => {
          commonsService.fileUpload(self.commonsConstants.fileConstants.upload.images)
            .then(function (result) {
              $scope._afterUpload(result);
            })
            .catch(function () {
              $log.info('Closed File Upload')
            })
        }

        $scope.onRemoveAttachment = (index) => {
          $scope.revertTaskReason.attachments.splice(index, 1);
        }

        $scope._afterUpload = (uploadedResult) => {
          const imageUrl = _.get(uploadedResult, 'url'),
            mimeType = _.get(uploadedResult, 'contentType');

          if (imageUrl) {
            const attachment = {
              url: imageUrl,
              mimeType: mimeType
            };
            $scope.revertTaskReason.attachments.push(attachment);
          }
        }

        $scope.cancel = self.$mdDialog.cancel;

        $scope.submit = (form) => {
          if (form) {
            form.$setSubmitted(true);
            if (form.$valid) {
              self.$mdDialog.hide($scope.revertTaskReason);
            }
          }
        };
      },
      targetEvent: event,
      fullscreen: true,
      clickOutsideToClose: false
    })
  }

  createThreeplServiceCancelReason(serviceIds, event?, header?, isShowAttachment?, entities?) {
    const self = this;
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      template: require('./../views/threepl-service-cancel-reason.html').default,
      controller: function ($scope, commonsService: CommonsService, $log, $mdMedia) {

        $scope.isCancellationCommentMandatory = self.siteContextService.getSiteInfo().serviceCustomizedFields.cancelServiceCommentIsMandatory;
        $scope.serviceIds = serviceIds;

        $scope.header = header;
        $scope.selectedServices = undefined;
        $scope.cancelableServices = undefined;
        $scope.unCancelableServices = undefined;
        $scope.cancelRelatedChecked = undefined;
        $scope.isRouted;
        $scope.cancellationReasonVisibilitiesType = ActionReasonVisibilityEnum;
        $scope.isShowAttachment = isShowAttachment;
        $scope.entities = entities;

        $scope.actionReasonTypes = [ActionReasonEnum.Cancel];
        $scope.actionReasonVisibiltyTypes = ActionReasonVisibilityEnum;


        $scope.isMobile = !$mdMedia('gt-md');
        $scope.cancellationReasonTypes = [ActionReasonEntityEnum.Delivery];

        $scope.selectedCancellationReason = undefined;

        $scope.cancelTaskReason = {
          reason: undefined,
          externalId: undefined,
          description: undefined,
          actions: [],
          comment: undefined,
          attachments: [],
          serviceType: undefined,
          removeFromRoute: true
        }


        $scope.onChangeCancellationReason = (cancellationReason: ActionReasonModel) => {
          if (!cancellationReason) return;
          $scope.selectedCancellationReason = cancellationReason;
          $scope.cancelTaskReason.reason = cancellationReason.reason;
          $scope.cancelTaskReason.externalId = cancellationReason.externalId;
          $scope.cancelTaskReason.description = cancellationReason.description;
          $scope.cancelTaskReason.actions = cancellationReason.actions;
          $scope.cancelTaskReason.typeToCancel = cancellationReason.entityType;
        }

        $scope.onAddAttachment = () => {
          commonsService.fileUpload(self.commonsConstants.fileConstants.upload.images)
            .then(function (result) {
              $scope._afterUpload(result);
            })
            .catch(function () {
              $log.info('Closed File Upload')
            })
        }

        $scope.onRemoveAttachment = (index) => {
          $scope.cancelTaskReason.attachments.splice(index, 1);
        }

        $scope._afterUpload = (uploadedResult) => {
          const imageUrl = _.get(uploadedResult, 'url'),
            mimeType = _.get(uploadedResult, 'contentType');

          if (imageUrl) {
            const attachment = {
              url: imageUrl,
              mimeType: mimeType
            };
            $scope.cancelTaskReason.attachments.push(attachment);
          }
        }

        $scope.cancel = self.$mdDialog.cancel;

        $scope.submit = (form) => {
          if (form) {
            form.$setSubmitted(true);
            if (form.$valid) {
              let cancelableServicesIds = [];
              if ($scope.cancelRelatedChecked) {
                cancelableServicesIds = _.map($scope.cancelableServices, (s) => {
                  return s.id
                })
              }

              self.$mdDialog.hide({
                cancelReason: $scope.cancelTaskReason,
                relatedServicesIds: cancelableServicesIds
              });
            }
          }
        };
      },
      targetEvent: event,
      fullscreen: true,
      clickOutsideToClose: false
    })
  }

  changeToBackInStore(event) {
    const self = this;
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      template: require('./../views/back-in-store.html').default,
      controller: function ($scope, commonsService: CommonsService, $log) {

        $scope.backInStoreReason = {
          title: self.$filter('translate')('Back in Store'),
          text: self.$filter('translate')('The package is back in store'),
          attachments: []
        }

        $scope.onAddAttachment = () => {
          commonsService.fileUpload(self.commonsConstants.fileConstants.upload.images)
            .then(function (result) {
              $scope._afterUpload(result);
            })
            .catch(function () {
              $log.info('Closed File Upload')
            })
        }

        $scope._afterUpload = (uploadedResult) => {
          const imageUrl = _.get(uploadedResult, 'url'),
            mimeType = _.get(uploadedResult, 'contentType');

          if (imageUrl) {
            const attachment = {
              url: imageUrl,
              mimeType: mimeType
            };
            $scope.backInStoreReason.attachments.push(attachment);
          }
        }

        $scope.onRemoveAttachment = (index) => {
          $scope.backInStoreReason.attachments.splice(index, 1);
        }

        $scope.cancel = self.$mdDialog.cancel;
        $scope.submit = (form) => {
          if (form) {
            form.$setSubmitted(true);
            if (form.$valid) {
              self.$mdDialog.hide($scope.backInStoreReason);
            }
          }
        };
      },
      targetEvent: event,
      fullscreen: true,
      clickOutsideToClose: false
    })
  }

}

angular
  .module('bringoz.admin.action-reasons')
  .service('actionReasonsDialogsService', ActionReasonsDialogsServiceService);
